export const BASE_COLOR = 'var(--blue-50)';
export const COLORS = {
  A: 'var(--blue-50)',
  B: 'var(--red-70)',
  C: 'var(--red-70)',
  D: 'var(--yellow-70)',
  E: 'var(--gray80)',
  F: 'var(--mint-60)',
  G: 'var(--red-50)',
  H: 'var(--gray80)',
  I: 'var(--cyan-60)',
  J: 'var(--violet-50)',
  K: 'var(--blue-50)',
  L: 'var(--red-20)',
  M: 'var(--purple-60)',
  N: 'var(--red-70)',
  O: 'var(--orange-50)',
  P: 'var(--cyan-50)',
  Q: 'var(--orange-60)',
  R: 'var(--violet-60)',
  S: 'var(--orange-70)',
  T: 'var(--mint-60)',
  U: 'var(--gray50)',
  V: 'var(--yellow-60)',
  W: 'var(--gray50)',
  X: 'var(--gray70)',
  Y: 'var(--orange-50)',
  Z: 'var(--violet-70)',
};
export type ColorTypes = typeof COLORS;
